class AppStateService {
    constructor() {
        this._offcanvas = false;
        this._search = false;
        this._languageSelect = false;
        this.listeners = [];
    }
    get offcanvas() {
        return this._offcanvas;
    }
    get search() {
        return this._search;
    }
    get languageSelect() {
        return this._languageSelect;
    }
    toggleOffcanvas() {
        this._search = false;
        this._offcanvas = !this._offcanvas;
        this.callListeners();
    }
    toggleSearch() {
        this._offcanvas = false;
        this._search = !this._search;
        this.callListeners();
    }
    toggleLanguageSelect() {
        this._languageSelect = !this._languageSelect;
        this.callListeners();
    }
    toggleCart() {
        this._languageSelect = false;
        this.callListeners();
    }
    togglePortal() {
        this._languageSelect = false;
        this.callListeners();
    }
    addEventListener(listener) {
        this.listeners.push(listener);
        return () => {
            this.listeners = this.listeners.filter(_listener => _listener !== listener);
        };
    }
    removeEventListener(listener) {
        this.listeners = this.listeners.filter(_listener => _listener !== listener);
    }
    callListeners() {
        window.dispatchEvent(new CustomEvent('uvex-app-state-change', {
            detail: {
                offcanvas: this._offcanvas,
                search: this._search,
                languageSelect: this._languageSelect,
            }
        }));
        this.listeners.forEach((listener) => listener.apply(null, null));
    }
}
export const AppState = new AppStateService();
//# sourceMappingURL=app-state.js.map
